<template>
  <b-overlay
    :show="loader.form"
    rounded="sm"
  >
    <b-tabs
      fill
      pills
    >
      <!-- Datos de materia -->
      <b-tab
        title="Principal"
        active
      >
        <template #title>
          <feather-icon icon="ClipboardIcon" />
          <span>Principal</span>
        </template>
        <!-- Datos básicos de una materia -->

        <validation-observer ref="formMateria">
          <b-card class="blog-edit-wrapper">
            <titleSection
              v-if="!isEmptyObject(asignature)"
              :title="(asignature.info.nombre) ? asignature.info.nombre : 'Ingrese nombre de materia'"
              :subtitle="(asignature.info.clave) ? asignature.info.clave : 'Ingrese clave de materia'"
              icon="ClipboardIcon"
            />
            <!-- Nombre, Clave, Objetivo -->
            <b-form
              v-if="!isEmptyObject(asignature)"
              class="mt-2"
            >
              <b-row>
                <!-- Nombre -->
                <b-col md="9">
                  <b-form-group
                    label="Asignatura"
                    label-for="materia-title"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="nombre"
                      rules="required"
                    >
                      <b-form-input
                        id="materia-title"
                        v-model="asignature.info.nombre"
                        placeholder="Nombre"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Clave -->
                <b-col md="3">
                  <b-form-group
                    label="Clave"
                    label-for="materia-clave"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="clave"
                      rules="required|max:50"
                    >
                      <b-form-input
                        id="materia-clave"
                        v-model="asignature.info.clave"
                        placeholder="Clave"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Objetivo -->
                <b-col cols="12">
                  <b-form-group
                    label="Objetivo"
                    label-for="materia-objetivo"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="objetivo"
                      rules="required"
                    >
                      <b-form-textarea
                        id="materia-objetivo"
                        v-model="asignature.info.objetivo"
                        placeholder="Objetivo de la materia"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <!-- Departamento -->
                <b-col md="12">
                  <b-form-group
                    label="Departamento"
                    label-for="materia-departamento"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="departamento"
                      rules="required"
                    >
                      <v-select
                        id="materia-departamento"
                        v-model="asignature.info.depto"
                        placeholder="Sin departamento"
                        label="nombre"
                        :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="departamentos"
                        :reduce="dpto => dpto.id"
                        :clearable="false"
                      >
                        <template #no-options>
                          <em style="opacity: 0.5;">No hay resultados para mostar</em>
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  <!-- <small>La materia seleccionada, <b class="text-primary">será requisito</b> para poder cursar la materia de <b>{{ asignature.info.nombre }}</b></small> -->
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <!-- Botones de cancelación y guardado -->
            <div class="text-right">
              <!-- Save changes -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Guardar cambios
              </b-button>
              <!-- Cancel -->
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-danger"
                @click="(id) ? $emit('update:id', null) : $router.push('/servicio-escolar/dashboard')"
              >
                Cancelar
              </b-button>
            </div>
          </b-card>
        </validation-observer>
      </b-tab>
      <!-- Módulos de materia -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="LayersIcon" />
          <span>Módulos</span>
        </template>
        <b-card>
          <titleSection
            title="Módulos de materia"
            subtitle="Listado de módulos que serán impartidos"
            icon="LayersIcon"
            class="mb-2"
          />

          <edit-modulos-materia
            :materia="id"
            :modulos-prop.sync="asignature.modulos"
            @reload-data="loadAsignatureData"
            @set-loader="loader.form = $event"
          />
        </b-card>
      </b-tab>
      <!-- Seriación de materia -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="LogInIcon" />
          <span>Seriación</span>
        </template>
        <b-card>
          <titleSection
            title="Seriación de materia"
            subtitle="Requisito previo para poder cursar la asignatura"
            icon="LogInIcon"
            class="mb-2"
          />

          <edit-seriacion-materia
            :materia="id"
            :seriaciones-prop.sync="asignature.seriaciones"
            @reload-data="loadAsignatureData"
            @set-loader="loader.form = $event"
          />
        </b-card>
      </b-tab>
    </b-tabs>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BOverlay,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BTabs,
  BTab,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import titleSection from '@/views/components/title-section.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, onMounted, computed } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import { isEmptyObject } from '@core/utils/utils'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import editModulosMateria from './EditModulosMateria.vue'
import editSeriacionMateria from './EditSeriacionMateria.vue'
import { materiaInfo, departamentosList } from '../useMaterias'

export default {
  components: {
    BCard,
    BOverlay,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    BTabs,
    BTab,
    titleSection,
    editModulosMateria,
    editSeriacionMateria,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    totalMaterias: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const asignature = ref({})
    const loader = ref({ form: false })
    const seriacionSelected = ref(null)
    const departamentos = ref([])
    const formMateria = ref(null)

    // Computed method to get form values
    const getValuesToSend = computed(() => {
      const {
        clave, nombre, objetivo, depto,
      } = asignature.value.info

      return {
        clave, nombre, objetivo, depto,
      }
    })

    // Set asignature's data as an empty object
    const newAsignatureData = () => {
      asignature.value = {
        info: {
          id: null,
          clave: null,
          nombre: null,
          depto: null,
          objetivo: null,
          division: null,
        },
        modulos: [],
      }
    }

    // Save changes
    const saveChanges = () => {
      const toUpdate = getValuesToSend.value
      loader.value.form = true
      const data = {
        task: 'wsmaterias',
        action: props.id ? 4 : 3, // Si hay id es edición [4], sino nueva materia [3]
        materia: props.id,
        datos: JSON.stringify(toUpdate),
      }

      store.dispatch('servicioEscolar/postServicioEscolar', data)
        .then(response => {
          loader.value.form = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
          if (!props.id) {
            newAsignatureData()
            emit('refetch-data')
          }
        }, error => {
          loader.value.form = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Actualizar materia]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    // Load asignature's data
    const loadAsignatureData = () => {
      loader.value.form = true
      materiaInfo(props.id).then(response => {
        loader.value.form = false
        asignature.value = response
      }, error => {
        loader.value.form = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información de materia]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    // Load departamentos
    const loadDepartamentos = () => {
      departamentosList().then(response => {
        departamentos.value = response
      }, error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información de materia]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    onMounted(
      () => {
        if (props.id) loadAsignatureData() // If we have an id, so component will edit, get data
        else newAsignatureData() // Will create a new asignature, so put empty data
        loadDepartamentos()
      },
    )

    const validationForm = () => {
      formMateria.value.validate().then(success => {
        if (success) saveChanges()
      })
    }

    return {
      loadAsignatureData,
      newAsignatureData,
      saveChanges,
      loader,
      seriacionSelected,
      asignature,
      isEmptyObject,
      departamentos,

      required,
      formMateria,
      validationForm,
    }
  },
}
</script>
